<template>
  <div>
    <Navbar />
    <SlideShow />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/shared/Navbar.vue";
import SlideShow from "@/components/shared/SlideShow.vue";
import Contact from "@/components/contact/Contact.vue";
import Footer from "@/components/shared/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    SlideShow,
    Contact,
    Footer
  }
};
</script>
